export default __webpack_public_path__ + "40a283c.png";